import React from 'react'
import './portfolio.css'
import IMG1 from "../../assets/toni.png"
import IMG2 from "../../assets/gym.png"
import IMG3 from "../../assets/fine-dining.png"
import IMG4 from "../../assets/cinemate.png"
import IMG5 from "../../assets/admin.png"
import IMG6 from "../../assets/fiona.png"
// import IMG7 from "../../assets/marine-drive-hero.jpg"

export default function Portfoilo() {
  const data = [
    {
      id: 1,
      image: IMG1,
      title: 'Toni Jacqueline Makeup & More',
      // desc: '',
      tech: 'ASP.NET, Blazor, HTML, CSS, JavaScript',
      // github: 'https://github.com/trevormoir/tonijacqueline',
      demo: 'https://www.tonijacqueline.com',
      type: 'Live'
    },
    {
      id: 2,
      image: IMG2,
      title: 'React Gym Website Demo',
      // desc: '',
      tech: 'React, HTML, CSS, JavaScript',
      github: 'https://github.com/trevormoir/react-router-site',
      demo: 'https://trevormoir.com/gym/',
      type: 'Live Demo'
    },
    {
      id: 3,
      image: IMG3,
      title: 'Fine Dining Restaurant Demo',
      // desc: '',
      tech: 'React, HTML, CSS, JavaScript',
      github: 'https://github.com/trevormoir/fine-dining',
      demo: 'https://trevormoir.com/fine-dining',
      type: 'Live Demo'
    },
    {
      id: 4,
      image: IMG4,
      title: 'CineMate Movie Database',
      // desc: '',
      tech: 'React, HTML, CSS, JavaScript',
      github: 'https://github.com/trevormoir/cinemate',
      demo: 'https://cinemate.trevormoir.com/',
      type: 'Live Demo'
    },
    {
      id: 5,
      image: IMG5,
      title: 'Admin Dashboard w/ Graphs',
      // desc: '',
      tech: 'React, HTML, CSS, JavaScript',
      github: 'https://github.com/trevormoir/react-admin',
      demo: 'https://trevormoir.com/tm-admin',
      type: 'Live Demo'
    },
    {
      id: 6,
      image: IMG6,
      title: "Fiona O'Brien : Comedian Website",
      // desc: '',
      tech: 'WordPress, PHP, HTML, CSS, JavaScript',
      // github: 'https://github.com/trevormoir/Fiona-O-Brien',
      demo: 'https://www.fionaobrien.ca',
      type: 'Live'
    },
    // {
    //   id: 7,
    //   image: IMG7,
    //   title: "Marine Drive Golf Club",
    //   //desc: 'This is a description of the what the site is and does',
    //   tech: 'WordPress, PHP, HTML, CSS, JavaScript',
    //   // github: 'https://github.com/trevormoir/Fiona-O-Brien',
    //   demo: 'https://marinedrive.trevormoir.com',
    //   type: 'Live Demo'
    // },
  ]

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
      {
        data.map(({id, image, title, desc, tech, github, demo, type}) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              {desc && 
                <h5>{desc}</h5>
              }
              {tech &&
                <h6>Technologies: {tech}</h6>
              }
              <div className="portfolio__item-cta">
                {github &&
                  <a href={github} className="btn">Github</a>
                }
                <a href={demo} className="btn btn-primary" target="_blank" rel="noreferrer">{type}</a>
              </div>
            </article>
          )
        })
      }
      </div>
      <div className="container">
        <div className="portfolio__btn">
          <a href="https://trevormoir.com/portfolio" className="btn btn-primary" target="_blank" rel="noreferrer">More Portfolio Screens</a>
        </div>
      </div>
    </section>
  )
}
